import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from './FormMixin'
import useGlobal from '../../composables/useGlobal'
import MailChecker from 'mailchecker'
import {
  getFeedBack
} from '@/services/auth.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'CallBackForm',
  setup(__props, { expose }) {
  expose();

const { $t } = useGlobal()
const isSended: Ref<boolean> = ref(false)
const isLoad: Ref<boolean> = ref(false)
const email = ref("")

const request = (sendData: any, control: any) => {
  if(MailChecker.isValid(email.value)) {
    isLoad.value = true
    isSended.value = true
    useSubmit(send(sendData, control), control)
  } else {
    isSended.value = false
    isLoad.value = true
  }
}

const send = async (sendData, control) => {
  const prependedData = {
    ...sendData,
  }
  try {
    const res = (await getFeedBack.execute({}, prependedData))
  } catch(e) {
     e.json().then(body => {
        Object.keys(body).forEach(key => {
          control.setFieldError(key, body[key][0])
        })
      })
    isLoad.value = false
    return Promise.reject(e)
  }
}


const __returned__ = { $t, isSended, isLoad, email, request, send, ref, useSubmit, useGlobal, MailChecker, getFeedBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})